var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSlideSeminars(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4472 11.4493C14.0846 11.4493 16.2226 9.31128 16.2226 6.67392C16.2226 4.03655 14.0846 1.89856 11.4472 1.89856C8.80987 1.89856 6.67188 4.03655 6.67188 6.67392C6.67188 9.31128 8.80987 11.4493 11.4472 11.4493Z",
    stroke: "#215250",
    strokeWidth: 3.43,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.89844 28.163H6.67379L8.26558 40.1014H16.2245L17.8163 18.6123H25.3773C27.3553 18.6123 28.9588 17.0088 28.9588 15.0307C28.9588 13.0527 27.3553 11.4492 25.3773 11.4492H11.4492C6.17445 11.4492 1.89844 15.7252 1.89844 20.9999V28.163Z",
    stroke: "#215250",
    strokeWidth: 3.43,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5938 1.89856H36.9198C38.6781 1.89856 40.1034 3.32391 40.1034 5.08213V24.1836C40.1034 25.9418 38.6781 27.3671 36.9198 27.3671H24.1855",
    stroke: "#EA7F4A",
    strokeWidth: 3.43,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlideSeminars);
export default __webpack_public_path__ + "static/media/slide-seminars.75353ef6494032f747abdd5afe02ff60.svg";
export { ForwardRef as ReactComponent };